

/**
 * Checks, if `$el` is in the list of elements related to the event.
 * Example usage: Bind an `click` event to the `document`, but check if
 * `$el` was under the mouse pointer when clicked.
 * 
 * @see @/extensions/plugins/hitTest.js 
 * @return Boolean
 */
export const hitTest = function ( event, $el ) {
	if (!event) return false;
	var path = event.path || (event.composedPath && event.composedPath());
	if (!path) return false;
	return path.indexOf($el) > -1;
}

/**
 * Normalizes touch and click events to look identical.
 * 
 * @return object
 */
export const normalizeEvent = function ( event ) {
	var ref = event.touches ? event.touches[0] : event;
	if (!ref) ref = {};
	return {
		x: ref.pageX || event.x,
		y: ref.pageY || event.y,
		tstamp: event.timeStamp,
		path: event.path || (event.composedPath && event.composedPath()) || false,
		originalEvent: event,
	}
}
